export default {
      id: "indication-arrow-up-usage",
      viewBox: "0 0 20 60.00031",
      url: "images/" + "sprite.svg#indication-arrow-up-usage",
      toString: function () {
        return this.url;
      }
    }